import React, { Fragment, useState, useCallback, useEffect } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardHeader, Media, Modal, ModalHeader, ModalBody, CardBody, Form, FormGroup, Input, Label, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import { Email, ContactUs } from '../../../constant'
import { createClient } from "@supabase/supabase-js";
import { toast } from 'react-toastify';
import { ReactBingmaps } from "react-bingmaps";
import { Geolocation } from '@capacitor/geolocation';
import { Toast } from '@capacitor/toast';
import { Icon } from '@iconify/react';
import "./styles.css"
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const Account = (props) => {


    const [url, setUrl] = useState();

    const readUrl = async (event) => {
        if (event.target.files.length === 0)
            return;
        var mimeType = event.target.files[0].type;

        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            setUrl(reader.result)

        }
        const avatarFile = event.target.files[0]

        await supabase.storage
            .from('user')
            .remove([useremail])

        const { data, error } = await supabase.storage
            .from('user')
            .upload(useremail, avatarFile)

        if (data !== null) {
            const { publicURL, error1 } = supabase.storage
                .from('user')
                .getPublicUrl(useremail)

            if (publicURL !== null) {
                const { data, error } = await supabase
                    .from('User_Details')
                    .update({ user_pic: publicURL })
                    .eq('user_email', useremail)

                if (data !== null) {
                    if (usertype === "Supplier") {
                        await supabase
                            .from('supplier_details')
                            .update({ man_name: name, man_pic: data[0].user_pic })
                            .eq('man_id', data[0].user_id)
                        await supabase
                            .from('trip_details')
                            .update({ man_name: name })
                            .eq('man_id', data[0].user_id)
                        await supabase
                            .from('invoice_details')
                            .update({ man_name: name })
                            .eq('man_id', data[0].user_id)
                        await supabase
                            .from('vehicle_invoice_details')
                            .update({ man_name: name })
                            .eq('man_id', data[0].user_id)
                    } else if (usertype === "Driver") {
                        await supabase
                            .from('driver_details')
                            .update({ driver_name: name, driver_pic: data[0].user_pic })
                            .eq('driver_id', data[0].user_id)
                        await supabase
                            .from('trip_details')
                            .update({ driver_name: name })
                            .eq('driverid', data[0].user_id)

                        await supabase
                            .from('vehicle_invoice_details')
                            .update({ driver_name: name })
                            .eq('driver_id', data[0].user_id)

                    } else if (usertype === "Buyer") {
                        await supabase
                            .from('Buyer_details')
                            .update({ customer_name: name, customer_pic: data[0].user_pic })
                            .eq('customer_id', data[0].user_id)
                        await supabase
                            .from('invoice_details')
                            .update({ customer_name: name })
                            .eq('customer_id', data[0].user_id)
                        await supabase
                            .from('trip_details')
                            .update({ customer_name: name })
                            .eq('customer_id', data[0].user_id)

                        await supabase
                            .from('vehicle_invoice_details')
                            .update({ customer_name: name })
                            .eq('customer_id', data[0].user_id)


                    } else if (usertype === "Vehicle Owner") {
                        await supabase
                            .from('vehicle_details')
                            .update({ vehicle_owner_name: name, vehicle_pic: data[0].user_pic })
                            .eq('vehicle_id', data[0].user_id)





                    }
                    toast.success("User Profile Pic Updated Successfully")


                    initializeUser()
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000)

                } else {
                    toast.error("User Profile Pic Update Failed")
                }
            }





        }





    }
    const [name, setname] = useState('')
    const [email, setemail] = useState('')
    const [mobilenumber, setmobilenumber] = useState('')
    const [address, setAddress] = useState('')
    const [gstnumber, setgstnumber] = useState('')
    const [tinno, settinno] = useState('')
    const [aadharno, setaadharno] = useState('')
    const [dob, setdob] = useState('')
    const [vehicletype, setvehicletype] = useState('')
    const [vehiclenumber, setvehiclenumber] = useState('')
    const [vehiclebodyweight, setvehiclebodyweight] = useState("")
    const [vehicletonnage, setvehicletonnage] = useState("")
    const [buyertype, setbuyertype] = useState("")
    const [suppliertype, setsuppliertype] = useState("Manufacturer")
    const [licensetype, setlicensetype] = useState("")
    const [licenseno, setlicenseno] = useState("")
    const [customer_type, setcustomer_type] = useState([])
    const [supplier_type, setsupplier_type] = useState([])
    const [license_type, setlicense_type] = useState([])
    const [vehicle_type, setvehicle_type] = useState([])
    const [supplier_coordinate, setsupplier_coordinate] = useState("")
    
    const [userDetail, setUserDetail] = useState([]);
    const [usertype, setUsertype] = useState("");
    const [useremail, setUseremail] = useState("");
    const [clientHeight, setclientHeight] = useState("")
    const [userphone, setUserphone] = useState("");
    const [userdob, setUserdob] = useState("");
    const [editon, setEditon] = useState(false);
    const [Large, setLarge] = useState(false);
    const [lang, setLang] = useState("");
    const [lat, setLat] = useState("");
    const [lng, setLng] = useState("");
    const [pushpinarr, setPushpinarr] = useState([{
        "latitude": 16.132097048356034,
        "longitude": 80.82997610219755,
        "title": "Supplier",
        "description": "Supplier",
    }]);
    var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    };
    const [loc, setLoc] = useState(null);
    const validatevehicleno = (vehicleno) => {
        var vehreg = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/
        if (vehicleno.length == 10 || vehicleno.length == 9) {
            return true
        } else {
            return false
        }
    }
    const validatelicenseno = (licenseno) => {
        var regex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;
        if (regex.test(licenseno)) {
            return true;
        } else {
            return false;
        }
    }
    const validateaadharno = (aadharno) => {
        var reg = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
        if (reg.test(aadharno)) {
            return true;
        } else {
            return false;
        }

    }
    const validategst = (gst) => {
        var gstreg = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/
        if (gstreg.test(gst)) {
            return true;
        } else {
            return false;
        }
    }

    const validateemail = (email) => {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        if (re.test(email)) {
            return true
        } else {
            return false
        }
    }
    function AddPushPinOnClick(e) {



        var arr = [];



        arr.push({
            "latitude": e.latitude,
            "longitude": e.longitude,
            "type": "Supplier",
            "title": "Supplier",
            "description": "Supplier Location",
        })
        setsupplier_coordinate(e.longitude + "," + e.latitude)

        setPushpinarr(arr);








    }

    const getCurrentPosition = useCallback(async () => {
        await Geolocation.getCurrentPosition().then(async (position) => {

            let { data: User_Details, error } = await supabase
                .from('User_Details')
                .update({ coordinates: `${position.coords.longitude},${position.coords.latitude}` })
                .eq('user_email', window.localStorage.getItem("useremail"))
            if (User_Details !== null) {
                await supabase
                    .from('trip_details')
                    .update({ driver_coordinates: `${position.coords.longitude},${position.coords.latitude}` })
                    .eq('driverid', User_Details[0].user_id)
                setUserDetail(User_Details)
            }
            setLoc(position);
        }).catch(async (err) => {

            if (err.message == "User denied Geolocation") {
                setTimeout(() => {
                    toast.error("Please Allow Location Access")

                }, 5000)
                await Toast.show({
                    text: 'Please Allow Location Permission',
                });
            }
        });



    }, [loc]);

    async function updatetype() {
        let { data: customer_type, error } = await supabase
            .from('customer_type_details')
            .select('*')

        if (error === null) {

            setcustomer_type(customer_type)
        }

        let { data: supplier_type, error1 } = await supabase
            .from('supplier_type_details')
            .select('*')
        if (error1 === undefined) {
            setsupplier_type(supplier_type)
        }

        let { data: driver_license_type, error2 } = await supabase
            .from('driver_license_type')
            .select('*')

        if (error2 === undefined) {
            setlicense_type(driver_license_type)

        }

        let { data: vehicle_type, error3 } = await supabase
            .from('vehicle_type_details')
            .select('*')
        if (error3 === undefined) {
            setvehicle_type(vehicle_type)
        }
    }

    useEffect(() => {
        updatetype()
        if (window.localStorage.getItem("usertype") === "Driver") {
            setInterval(() => {
                getCurrentPosition();
            }, 5000)
        }

    }, [])


    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
    const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
    const supabase = createClient(supabaseUrl, supabaseKey);
    const LargeModaltoggle = () => {
        setLarge(!Large)
        setEditon(false)
    }
    async function updateuser() {
        const { data, error } = await supabase
            .from('User_Details')
            .update({ user_name: name, lang: lang })
            .eq('user_email', useremail)

        if (data !== null) {

            if (usertype === "Supplier") {
                await supabase
                    .from('supplier_details')
                    .update({ man_name: name, man_pic: data[0].user_pic,man_address:address,man_tin:tinno,man_gstnumber:gstnumber,supplier_coordinate:supplier_coordinate,man_type:buyertype,man_vehicletype:vehicletype })
                    .eq('man_id', data[0].user_id)
                await supabase
                    .from('trip_details')
                    .update({ man_name: name,man_address:address,supplier_coordinate:supplier_coordinate })
                    .eq('man_id', data[0].user_id)
                await supabase
                    .from('invoice_details')
                    .update({ man_name: name,man_address:address })
                    .eq('man_id', data[0].user_id)
                await supabase
                    .from('vehicle_invoice_details')
                    .update({ man_name: name,man_address:address,man_gstnumber:gstnumber})
                    .eq('man_id', data[0].user_id)
            } else if (usertype === "Driver") {
                await supabase
                    .from('driver_details')
                    .update({ driver_name: name, driver_pic: data[0].user_pic,driver_licence:licenseno,driver_aadhar_no:aadharno,driver_dob:dob,driver_licensetype:licensetype })
                    .eq('driver_id', data[0].user_id)
                await supabase
                    .from('trip_details')
                    .update({ driver_name: name })
                    .eq('driverid', data[0].user_id)

                await supabase
                    .from('vehicle_invoice_details')
                    .update({ driver_name: name,driver_license_no:licenseno })
                    .eq('driver_id', data[0].user_id)

            } else if (usertype === "Buyer") {
                await supabase
                    .from('Buyer_details')
                    .update({ customer_name: name, customer_pic: data[0].user_pic,customer_address:address,customer_gstnumber:gstnumber,customer_type:buyertype,customer_vehicletype:vehicletype,customer_vehiclenumber:vehiclenumber,customer_aadhar_no:aadharno,customer_dob:dob })
                    .eq('customer_id', data[0].user_id)
                await supabase
                    .from('invoice_details')
                    .update({ customer_name: name,customer_address:address,customer_deliveryaddress:address,customer_gstnumber:gstnumber })
                    .eq('customer_id', data[0].user_id)
                await supabase
                    .from('trip_details')
                    .update({ customer_name: name,customer_address:address,customer_deliveryaddress:address })
                    .eq('customer_id', data[0].user_id)

                await supabase
                    .from('vehicle_invoice_details')
                    .update({ customer_name: name,customer_address:address,customer_gstnumber:gstnumber })
                    .eq('customer_id', data[0].user_id)


            } else if (usertype === "Vehicle Owner") {
                await supabase
                    .from('vehicle_details')
                    .update({ vehicle_owner_name: name, vehicle_pic: data[0].user_pic,vehicle_type:vehicletype,vehicle_number:vehiclenumber,vehicle_tonnage:vehicletonnage,vehicle_bodyweight:vehiclebodyweight,vehicle_owner_aadharno:aadharno,vehicle_owner_dob:dob })
                    .eq('vehicle_id', data[0].user_id)
                    await supabase
                    .from('trip_details')
                    .update({ vehicle_number:vehiclenumber})
                    .eq('vehicle_id', data[0].user_id)
                    await supabase
                    .from('vehicle_invoice_details')
                    .update({ vehicle_type:vehicletype,vehicle_no:vehiclenumber })
                    .eq('vehicle_id', data[0].user_id)





            }
            toast.success("User Updated Successfully")
            setLarge(!Large)
            initializeUser()

        } else {
            toast.error("User Update Failed")
        }

    }

    const initializeUser = async () => {
        const user = supabase.auth.user();



        if (user !== null) {

            if (window.localStorage.getItem("LoggedInType") === "Mobile") {
                let { data: User_Details, error } = await supabase
                    .from('User_Details')
                    .select("*")
                    .eq('user_phone', user.phone)

                if (User_Details !== null && User_Details.length > 0) {
                    setUserDetail(User_Details)
                    setTimeout(() => {
                        setclientHeight(window.innerHeight * 0.8)

                    }, 1000)
                   

                    setUsertype(User_Details[0].user_type)
                    setUseremail(User_Details[0].user_email)
                    setUserphone(User_Details[0].user_phone)

                    setUserdob(User_Details[0].user_dob)
                    setUrl(User_Details[0].user_pic)
                    if (User_Details[0].lang !== null) {
                        setLang(User_Details[0].lang)
                    }
                    if (User_Details[0].user_type == "Driver") {
                        let { data: driver_details, error } = await supabase
                            .from('driver_details')
                            .select('*')
                            .eq('driver_id', User_Details[0].user_id)

                        if (driver_details !== null && driver_details.length > 0) {
                            setname(driver_details[0].driver_name)
                            setmobilenumber(driver_details[0].driver_phone.toString().slice(2, 12))
                            setemail(driver_details[0].driver_email)



                            if (driver_details[0].driver_aadhar_no == null) {
                                setaadharno("")
                            } else {
                                setaadharno(driver_details[0].driver_aadhar_no)
                            }
                            if (driver_details[0].driver_dob == "") {
                                setdob("")
                            } else {
                                setdob(driver_details[0].driver_dob)
                            }
                            setlicenseno(driver_details[0].driver_licence)
                            setlicensetype(driver_details[0].driver_licensetype)
                        }
                    } else if (User_Details[0].user_type == "Supplier") {
                        let { data: Supplier_Details, error } = await supabase
                            .from('Supplier_details')
                            .select('*')
                            .eq('man_id', User_Details[0].user_id)

                        if (Supplier_Details !== null && Supplier_Details.length > 0) {
                            setname(Supplier_Details[0].man_name)
                            setmobilenumber(Supplier_Details[0].man_phone.toString().slice(2, 12))
                            setemail(Supplier_Details[0].man_email)
                            setbuyertype(Supplier_Details[0].man_type)
                            setAddress(Supplier_Details[0].man_address)
                            setgstnumber(Supplier_Details[0].man_gstnumber)
                            settinno(Supplier_Details[0].man_tin)
                            setvehicletype(Supplier_Details[0].man_vehicletype)
                            if (Supplier_Details[0].supplier_coordinate !== null && Supplier_Details[0].supplier_coordinate !== "") {
                                setsupplier_coordinate(Supplier_Details[0].supplier_coordinate)

                                setPushpinarr([{
                                    "latitude": parseFloat(Supplier_Details[0].supplier_coordinate.split(",")[1]),
                                    "longitude": parseFloat(Supplier_Details[0].supplier_coordinate.split(",")[0]),
                                    "type": "Supplier",
                                    "title": "Supplier",
                                    "description": "Supplier Location",
                                }]);
                            }
                        }

                    } else if (User_Details[0].user_type == "Buyer") {
                        let { data: Buyer_Details, error } = await supabase
                            .from('Buyer_details')
                            .select('*')
                            .eq('customer_id', User_Details[0].user_id)

                        if (Buyer_Details !== null && Buyer_Details.length > 0) {
                            setname(Buyer_Details[0].customer_name)
                            setmobilenumber(Buyer_Details[0].customer_phone.toString().slice(2, 12))
                            setemail(Buyer_Details[0].customer_email)
                            setbuyertype(Buyer_Details[0].customer_type)
                            setAddress(Buyer_Details[0].customer_address)
                            setgstnumber(Buyer_Details[0].customer_gstnumber)
                            if (Buyer_Details[0].customer_aadhar_no === null) {
                                setaadharno("")
                            } else {
                                setaadharno(Buyer_Details[0].customer_aadhar_no)
                            }
                            if (Buyer_Details[0].customer_dob === "") {
                                setdob("")
                            } else {
                                setdob(Buyer_Details[0].customer_dob)
                            }
                            
                            setvehicletype(Buyer_Details[0].customer_vehicletype)
                            setvehiclenumber(Buyer_Details[0].customer_vehiclenumber)
                        }
                    } else if (User_Details[0].user_type == "Vehicle Owner") {
                        let { data: vehicle_details, error } = await supabase
                            .from('vehicle_details')
                            .select('*')
                            .eq('vehicle_id', User_Details[0].user_id)

                        if (vehicle_details !== null && vehicle_details.length > 0) {
                            setname(vehicle_details[0].vehicle_owner_name)
                            setmobilenumber(vehicle_details[0].vehicle_owner_number.toString().slice(2, 12))
                            setemail(vehicle_details[0].vehicle_owner_email)



                            if (vehicle_details[0].vehicle_owner_aadharno === null) {
                                setaadharno("")
                            } else {
                                setaadharno(vehicle_details[0].vehicle_owner_aadharno)
                            }
                            if (vehicle_details[0].vehicle_owner_dob === "") {
                                setdob("")
                            } else {
                                setdob(vehicle_details[0].vehicle_owner_dob)
                            }
                            setvehiclenumber(vehicle_details[0].vehicle_number)
                            setvehicletype(vehicle_details[0].vehicle_type)
                            setvehiclebodyweight(vehicle_details[0].vehicle_bodyweight)
                            setvehicletonnage(vehicle_details[0].vehicle_tonnage)
                        }
                    }

                    localStorage.setItem("name", User_Details[0].user_name);
                    localStorage.setItem("userimage", User_Details[0].user_pic);
                    localStorage.setItem("usertype", User_Details[0].user_type);
                    localStorage.setItem("useremail", User_Details[0].user_email);
                    localStorage.setItem("userid", User_Details[0].user_id);

                }

            } else {
                let { data: User_Details, error } = await supabase
                    .from('User_Details')
                    .select("*")
                    .eq('user_email', user.email)

                if (User_Details !== null && User_Details.length > 0) {
                    setUserDetail(User_Details)
                    setTimeout(() => {
                        setclientHeight(window.innerHeight * 0.8)

                    }, 1000)
                   

                    setUsertype(User_Details[0].user_type)
                    setUseremail(User_Details[0].user_email)
                    setUserphone(User_Details[0].user_phone)
                    setUrl(User_Details[0].user_pic)
                    setUserdob(User_Details[0].user_dob)
                    if (User_Details[0].lang !== null) {
                        setLang(User_Details[0].lang)
                    }
                    if (User_Details[0].user_type == "Driver") {
                        let { data: driver_details, error } = await supabase
                            .from('driver_details')
                            .select('*')
                            .eq('driver_id', User_Details[0].user_id)

                        if (driver_details !== null && driver_details.length > 0) {
                            setname(driver_details[0].driver_name)
                            setmobilenumber(driver_details[0].driver_phone.toString().slice(2, 12))
                            setemail(driver_details[0].driver_email)



                            if (driver_details[0].driver_aadhar_no == null) {
                                setaadharno("")
                            } else {
                                setaadharno(driver_details[0].driver_aadhar_no)
                            }
                            if (driver_details[0].driver_dob == "") {
                                setdob("")
                            } else {
                                setdob(driver_details[0].driver_dob)
                            }
                            setlicenseno(driver_details[0].driver_licence)
                            setlicensetype(driver_details[0].driver_licensetype)
                        }
                    } else if (User_Details[0].user_type == "Supplier") {
                        
                        let { data: Supplier_Details, error } = await supabase
                            .from('supplier_details')
                            .select('*')
                            .eq('man_id', User_Details[0].user_id)

                        if (Supplier_Details !== null && Supplier_Details.length > 0) {
                            setname(Supplier_Details[0].man_name)
                            setmobilenumber(Supplier_Details[0].man_phone.toString().slice(2, 12))
                            setemail(Supplier_Details[0].man_email)
                            setbuyertype(Supplier_Details[0].man_type)
                            setAddress(Supplier_Details[0].man_address)
                            setgstnumber(Supplier_Details[0].man_gstnumber)
                            settinno(Supplier_Details[0].man_tin)
                            setvehicletype(Supplier_Details[0].man_vehicletype)
                            if (Supplier_Details[0].supplier_coordinate !== null && Supplier_Details[0].supplier_coordinate !== "") {
                               
                                setsupplier_coordinate(Supplier_Details[0].supplier_coordinate)

                                setPushpinarr([{
                                    "latitude": parseFloat(Supplier_Details[0].supplier_coordinate.split(",")[1]),
                                    "longitude": parseFloat(Supplier_Details[0].supplier_coordinate.split(",")[0]),
                                    "type": "Supplier",
                                    "title": "Supplier",
                                    "description": "Supplier Location",
                                }]);
                            }
                        }

                    } else if (User_Details[0].user_type == "Buyer") {
                        let { data: Buyer_Details, error } = await supabase
                            .from('Buyer_details')
                            .select('*')
                            .eq('customer_id', User_Details[0].user_id)

                        if (Buyer_Details !== null && Buyer_Details.length > 0) {
                            setname(Buyer_Details[0].customer_name)
                            setmobilenumber(Buyer_Details[0].customer_phone.toString().slice(2, 12))
                            setemail(Buyer_Details[0].customer_email)
                            setbuyertype(Buyer_Details[0].customer_type)
                            setAddress(Buyer_Details[0].customer_address)
                            setgstnumber(Buyer_Details[0].customer_gstnumber)
                            if (Buyer_Details[0].customer_aadhar_no === null) {
                                setaadharno("")
                            } else {
                                setaadharno(Buyer_Details[0].customer_aadhar_no)
                            }
                            if (Buyer_Details[0].customer_dob === "") {
                                setdob("")
                            } else {
                                setdob(Buyer_Details[0].customer_dob)
                            }
                            
                            setvehicletype(Buyer_Details[0].customer_vehicletype)
                            setvehiclenumber(Buyer_Details[0].customer_vehiclenumber)
                        }
                    } else if (User_Details[0].user_type == "Vehicle Owner") {
                        let { data: vehicle_details, error } = await supabase
                            .from('vehicle_details')
                            .select('*')
                            .eq('vehicle_id', User_Details[0].user_id)

                        if (vehicle_details !== null && vehicle_details.length > 0) {
                            setname(vehicle_details[0].vehicle_owner_name)
                            setmobilenumber(vehicle_details[0].vehicle_owner_number.toString().slice(2, 12))
                            setemail(vehicle_details[0].vehicle_owner_email)



                            if (vehicle_details[0].vehicle_owner_aadharno === null) {
                                setaadharno("")
                            } else {
                                setaadharno(vehicle_details[0].vehicle_owner_aadharno)
                            }
                            if (vehicle_details[0].vehicle_owner_dob === "") {
                                setdob("")
                            } else {
                                setdob(vehicle_details[0].vehicle_owner_dob)
                            }
                            setvehiclenumber(vehicle_details[0].vehicle_number)
                            setvehicletype(vehicle_details[0].vehicle_type)
                            setvehiclebodyweight(vehicle_details[0].vehicle_bodyweight)
                            setvehicletonnage(vehicle_details[0].vehicle_tonnage)
                        }
                    }


                    localStorage.setItem("name", User_Details[0].user_name);
                    localStorage.setItem("userimage", User_Details[0].user_pic);
                    localStorage.setItem("usertype", User_Details[0].user_type);
                    localStorage.setItem("useremail", User_Details[0].user_email);
                    localStorage.setItem("userid", User_Details[0].user_id);

                }

            }

        } else {
            localStorage.setItem("currentUser", "null")
            localStorage.removeItem("name");
            localStorage.removeItem("userimage");
            localStorage.removeItem("usertype");
            localStorage.removeItem("useremail");
            window.location.href = "/";
        }


    };

    async function SignOut() {
        await supabase.auth.signOut();
        window.location.href = "/";
        localStorage.setItem("currentUser", "null")
        localStorage.removeItem("name");
        localStorage.removeItem("userimage");
        localStorage.removeItem("usertype");
        localStorage.removeItem("useremail");
        localStorage.removeItem("userid");


    }
    useEffect(() => {

        initializeUser();






        supabase.auth.onAuthStateChange((event, session) => {

            if (event === "SIGNED_IN") initializeUser();
        });
    }, [])



    return (
        <Fragment>
            <Breadcrumb parent="Users" title="Account Details" />
            <Container fluid={true}>
                <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
                    <ModalHeader toggle={LargeModaltoggle}>

                        MyProfile

                    </ModalHeader>
                    <ModalBody>
                        <Card>



                            <CardBody>
                                <Form>
                                    {editon ?
                                        <>
                                            {usertype === "Driver" ?
                                                <Row>
                                                    <Col>
                                                        <FormGroup className="row">
                                                            <div className="col-auto">
                                                                <Media className="img-70 rounded-circle" alt="" src={url} />
                                                            </div>
                                                            <Col>
                                                                <h3 className="mb-1">{name}</h3>
                                                                <p className="mb-4">{usertype}</p>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">License Type<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">

                                                                <Input className="form-control" type="select" placeholder="Choose Your License Type" value={licensetype} onChange={(e) => { setlicensetype(e.target.value) }}>
                                                                    <option value={""}>Choose Your License Type</option>
                                                                    {license_type.map((data, i) => {

                                                                        return (
                                                                            <option key={i} value={data.license_type}>{data.license_type}</option>
                                                                        )
                                                                    })}
                                                                </Input>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">License No<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="text" placeholder="Enter Your License No" value={licenseno} onChange={(e) => { setlicenseno(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <InputGroup>
                                                                    <InputGroupAddon addonType="prepend">
                                                                        <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly />
                                                                </InputGroup>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                {email === "" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly />}

                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>





                                                    </Col>
                                                </Row> : ""}
                                            {usertype === "Vehicle Owner" ? <Row>
                                                <Col>
                                                    <FormGroup className="row">
                                                        <div className="col-auto">
                                                            <Media className="img-70 rounded-circle" alt="" src={url} />
                                                        </div>
                                                        <Col>
                                                            <h3 className="mb-1">{name}</h3>
                                                            <p className="mb-4">{usertype}</p>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                                        </Col>
                                                    </FormGroup>

                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <InputGroup>
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly />
                                                            </InputGroup>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            {email === "" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly />}

                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                                                <option value={""}>Choose Your Vehicle Type</option>
                                                                {vehicle_type.map((data, i) => {

                                                                    return (
                                                                        <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                                                    )
                                                                })}
                                                            </Input>

                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                                                                setvehiclenumber(e.target.value)
                                                            }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Vehicle Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Vehicle Tonnage" value={vehicletonnage} onChange={(e) => {
                                                                setvehicletonnage(e.target.value)
                                                            }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Vehicle BodyWeight<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="number" placeholder="Enter Vehicle BodyWeight" value={vehiclebodyweight} onChange={(e) => {
                                                                setvehiclebodyweight(e.target.value)
                                                            }} />
                                                        </Col>
                                                    </FormGroup>





                                                </Col>
                                            </Row> : ""}
                                            {usertype === "Buyer" ?
                                                <Row>
                                                    <Col>
                                                        <FormGroup className="row">
                                                            <div className="col-auto">
                                                                <Media className="img-70 rounded-circle" alt="" src={url} />
                                                            </div>
                                                            <Col>
                                                                <h3 className="mb-1">{name}</h3>
                                                                <p className="mb-4">{usertype}</p>
                                                            </Col>
                                                        </FormGroup>

                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <InputGroup>
                                                                    <InputGroupAddon addonType="prepend">
                                                                        <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>
                                                                </InputGroup>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                {email === "" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly />}

                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <hr></hr>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label"> Aadhar No</Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label"> Date Of Birth</Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Buyer Type<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">

                                                                <Input className="form-control" type="select" value={buyertype} onChange={(e) => {
                                                                    setbuyertype(e.target.value)
                                                                }}>
                                                                    <option value={""}>Choose Your Buyer Type</option>
                                                                    {customer_type.map((data, i) => {

                                                                        return (
                                                                            <option key={i} value={data.customer_type}>{data.customer_type}</option>
                                                                        )
                                                                    })}
                                                                </Input>
                                                            </Col>
                                                        </FormGroup>

                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                                                    <option value={""}>Choose Your Vehicle Type</option>
                                                                    {vehicle_type.map((data, i) => {

                                                                        return (
                                                                            <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                                                        )
                                                                    })}
                                                                </Input>

                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                            <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                                                            <Col sm="12">
                                                                <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                                                                    setvehiclenumber(e.target.value)
                                                                }} />
                                                            </Col>
                                                        </FormGroup>






                                                    </Col>
                                                </Row> : ""}
                                            {usertype === "Supplier" ? <Row>
                                                <Col>
                                                    <FormGroup className="row">
                                                        <div className="col-auto">
                                                            <Media className="img-70 rounded-circle" alt="" src={url} />
                                                        </div>
                                                        <Col>
                                                            <h3 className="mb-1">{name}</h3>
                                                            <p className="mb-4">{usertype}</p>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Supplier Type<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="select" value={suppliertype} onChange={(e) => {
                                                                setsuppliertype(e.target.value)
                                                            }}>
                                                                <option value={""}>Choose Your Supplier Type</option>
                                                                {supplier_type.map((data, i) => {

                                                                    return (
                                                                        <option key={i} value={data.supplier_type}>{data.supplier_type}</option>
                                                                    )
                                                                })}
                                                            </Input>

                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        {suppliertype === "Supplier" ? <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label> : <Label className="col-sm-12 col-form-label">Company Name<span style={{ color: "#E50014" }}>*</span></Label>}

                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <InputGroup>
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>
                                                            </InputGroup>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            {email === "" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly />}

                                                        </Col>
                                                    </FormGroup>


                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Tin No<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="text" placeholder="Enter Your Tin No" value={tinno} onChange={(e) => {
                                                                settinno(e.target.value)
                                                            }} />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                                                <option value={""}>Choose Your Vehicle Type</option>
                                                                {vehicle_type.map((data, i) => {

                                                                    return (
                                                                        <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                                                    )
                                                                })}
                                                            </Input>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup className="row">
                                                        <Label className="col-sm-12 col-form-label">Location <span style={{ color: "#E50014" }}>*</span></Label>
                                                        <Col sm="12">
                                                            <div className='map-four' >
                                                                <ReactBingmaps

                                                                    center={[pushpinarr[0].latitude, pushpinarr[0].longitude]}
                                                                    zoom={7}
                                                                    className="customClass"
                                                                    bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}
                                                                    getLocation={
                                                                        { addHandler: "click", callback: AddPushPinOnClick }
                                                                    }
                                                                    infoboxesWithPushPins={
                                                                        pushpinarr.length > 0 && pushpinarr.map((item) => {
                                                                            return (
                                                                                {


                                                                                    location: [item.latitude, item.longitude],

                                                                                    addHandler: "mouseover", //on mouseover the pushpin, infobox shown
                                                                                    infoboxOption: { title: item.title, description: item.description },
                                                                                    pushPinOption: { title: item.title, description: item.description },

                                                                                }
                                                                            );
                                                                        })


                                                                    }


                                                                />
                                                            </div>
                                                        </Col>
                                                    </FormGroup>






                                                </Col>
                                            </Row> : ""}</>

                                        : <>
                                            <Row className='mb-2'>
                                                <div className="form-group">
                                                    <button className="btn btn-primary btn-sm float-right" onClick={() => {
                                                        setEditon(true);
                                                       
                                                    }}
                                                    >
                                                        Edit Full Profile
                                                    </button>
                                                </div>
                                            </Row>

                                            <Row className="mb-2">
                                                <div className="col-auto">
                                                    <Media className="img-70 rounded-circle" alt="" src={url} />
                                                </div>
                                                <Col>
                                                    <h3 className="mb-1">{name}</h3>
                                                    <p className="mb-4">{usertype}</p>
                                                </Col>
                                            </Row>
                                            <FormGroup>
                                                <Label className="form-label">{"Name"}</Label>
                                                <Input className="form-control" type='text' placeholder="Enter Your Name" value={name} onChange={(e) => {
                                                    setname(e.target.value)
                                                }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="form-label">{"Preferred Language"}</Label>

                                                <Input className="form-control" type="select" value={lang} onChange={(e) => {
                                                    setLang(e.target.value)
                                                }}>
                                                    <option value={""}>Choose Your Prefered Language</option>

                                                    <option value={"en"}>{"English"}</option>
                                                    <option value={"hi"}>{"Hindi"}</option>



                                                </Input>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="form-label">{"Email Address"}</Label>
                                                <Input className="form-control" placeholder="your-email@domain.com" readOnly value={useremail} onChange={(e) => {
                                                    setUseremail(e.target.value)
                                                }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="form-label">{"Phone No"}</Label>
                                                <Input className="form-control" type="number" readOnly value={userphone.toString().slice(2, 12)} onChange={(e) => {
                                                    setUserphone(e.target.value)
                                                }} />
                                            </FormGroup>
                                        </>}

                                    <div className="form-footer">
                                        <button className="btn btn-primary btn-block" type='button' onClick={() => {
                                            updateuser()
                                        }}>{"Save"}</button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </ModalBody>
                </Modal>
                <div className="user-profile" style={{ marginBottom: "100px" }}>

                    {userDetail.length > 0 && userDetail.map((item, index) => {
                        return (

                            <Row key={index}>
                                <Col sm="12">
                                    <Card className="card hovercard text-center">
                                        <CardHeader className="cardheader"></CardHeader>

                                        <div className="user-image">
                                            <div className="avatar"><Media body alt="" src={item.user_pic} data-intro="This is Profile image" /></div>
                                            <div className="icon-wrapper" data-intro="Change Profile image here">
                                                <i className="icofont icofont-pencil-alt-5">
                                                    <input className="upload" type="file" onChange={(e) => readUrl(e)} />
                                                </i>
                                            </div>
                                        </div>

                                        <div className="info">
                                            <div style={{ display: "flex", float: "right", fontSize: "20px", cursor: "pointer" }} onClick={() => {
                                                LargeModaltoggle()
                                            }}><i className='fa fa-edit ' ></i></div>
                                            <br />
                                            <Row>
                                                <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
                                                    <Row >
                                                        <Col md="12">
                                                            <div className="ttl-info ">
                                                                <h6><i className="fa fa-envelope mr-2"></i> {Email}</h6><span>{item.user_email}</span>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </Col>
                                                <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
                                                    <div className="user-designation">
                                                        <div className="title"><a target="_blank" href="#javascript">{item.user_name}</a></div>
                                                        <div className="desc mt-2">{item.user_type}</div>
                                                    </div>
                                                </Col>
                                                <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
                                                    <Row>
                                                        <Col md="6">
                                                            <div className="ttl-info  ttl-xs-mt">
                                                                <h6><i className="fa fa-phone"></i>   {ContactUs}</h6><span>{item.user_phone.toString().slice(2, 12)}</span>
                                                            </div>
                                                        </Col>
                                                        <Col md="6">
                                                            <div className="ttl-info  ttl-xs-mt">
                                                                <h6><i className="fa fa-language"></i>   {"Prefered Language"}</h6><span>{item.lang == "en" ? "English" : "Hindi"}</span>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </Col>
                                            </Row>

                                            <br />
                                            {item.coordinates !== null ? <>
                                                {item.coordinates !== "" && item.user_type === "Driver" ? <>
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", zIndex: "1" }}>

                                                        <div className='map-two' >
                                                            <ReactBingmaps

                                                                center={[parseFloat(item.coordinates.split(",")[1]), parseFloat(item.coordinates.split(",")[0])]}
                                                                zoom={15}
                                                                className="customClass"
                                                                bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}
                                                                infoboxesWithPushPins={[

                                                                    {

                                                                        location: [parseFloat(item.coordinates.split(",")[1]), parseFloat(item.coordinates.split(",")[0])],
                                                                        addHandler: "mouseover", //on mouseover the pushpin, infobox shown
                                                                        infoboxOption: { title: "Driver" },
                                                                        pushPinOption: { title: "Driver", description: "Driver" },

                                                                    }
                                                                ]}

                                                            />
                                                        </div>
                                                        <br />
                                                    </div> <br /></> : ""}</> : ""}
                                            <button className='btn' style={{ boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)", backgroundColor: "whitesmoke", color: "black", border: "1px sold gray", padding: "10px", borderRadius: "5px" }} onClick={() => SignOut()}>Sign Out</button>

                                        </div>
                                    </Card>
                                </Col>

                            </Row>

                        )
                    })}


                </div>

            </Container>
        </Fragment>
    );
}

export default Account;